import axios from 'axios'
import * as utils from '@/mixins/utils'

export default() => {

	return axios.create({
		baseURL: process.env.DECON_API,
		withCredentials: false,
		headers: utils.authHeaderDownload()
        // headers: {
        // 	'Content-Type': 'application/x-www-form-urlencoded'
        // }
    })
}


// WEBPACK FOOTER //
// ./src/api/DownloadApi.js